import { tryParse } from '@/utils/try-parse'
import axios from 'axios'

const token = sessionStorage.getItem('adminCoreToken')
const user = sessionStorage.getItem('user')
const environments = sessionStorage.getItem('environments')
const userType = sessionStorage.getItem('userType')
const profile = sessionStorage.getItem('profile')
const tfa = sessionStorage.getItem('tfa')
const features = sessionStorage.getItem('features')

const initialState = {
	user: tryParse(user),
	loggedIn: token ? true : false,
	token: token ?? null,
	environments: tryParse(environments),
	userType: userType ?? null,
	profile: tryParse(profile),
	tfa: tfa ?? null,
	features: tryParse(features)
}

if (token) {
	axios.defaults.headers.common['Authorization'] = `Bearer ${token}`
}

function auth(state = initialState, action) {
	switch (action.type) {
		case 'auth/login': {
			return {
				...state,
				loggedIn: true,
				user: action.payload.user,
				token: action.payload.token,
				environments: action.environments,
				userType: action.userType,
				profile: action.profile,
				tfa: action.tfa,
				features: action.features
			}
		}

		case 'auth/logout': {
			return {
				...state,
				loggedIn: false,
				user: null,
				token: null,
				environments: null,
				userType: null,
				profile: null,
				tfa: null,
				features: null
			}
		}

		case 'auth/syncProfile': {
			return {
				...state,
				profile: action.payload
			}
		}

		default: {
			return state
		}
	}
}

export default auth
